import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = (measurementId) => {
  if (measurementId) {
    ReactGA.initialize(measurementId);
  }
};

// Track page views
export const trackPageView = (page) => {
  ReactGA.send({ hitType: 'pageview', page });
};

// One GA4 event. Names are GA4's own recommended events where one exists
// (generate_lead, sign_up), so they can be marked as key events in GA admin with
// no custom definition; everything else is snake_case. Never put an email
// address or any other PII in params: it violates GA's terms of service.
//
// The funnel, in order: page_view -> chat_open -> chat_start -> generate_lead.
export const track = (name, params = {}) => {
  try {
    ReactGA.event(name, params);
  } catch (err) {
    /* GA is optional: never let analytics break the page */
  }
};

export const trackNewsletterSignup = () => track('sign_up', { method: 'newsletter' });

export const trackSectionNavigation = (section) => track('section_click', { section });
